/**
 * Structural equality for JSON-shaped values: key order is ignored and an
 * `undefined` property equals an absent one (exactly what `JSON.stringify` —
 * the wire — does). Array order matters: task and dependency order is data.
 */
export function sameJson(a: unknown, b: unknown): boolean {
  if (a === b) return true;
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return false;
  if (Array.isArray(a) !== Array.isArray(b)) return false;
  if (Array.isArray(a)) {
    const other = b as unknown[];
    return a.length === other.length && a.every((item, i) => sameJson(item, other[i]));
  }
  const left = a as Record<string, unknown>;
  const right = b as Record<string, unknown>;
  const keys = new Set([...Object.keys(left), ...Object.keys(right)]);
  for (const key of keys) {
    if (!sameJson(left[key], right[key])) return false;
  }
  return true;
}
